export default {
  home: {
    hero: {
      badge: 'Centro de recursos independiente',
      title: 'USFans Spreadsheet — El centro de recursos completo',
      subtitle: 'Encuentra recursos de USFans spreadsheet, reseñas, información de envío, cupones, comparaciones y guías prácticas, todo organizado en un solo lugar.',
      ctaMain: 'usfans spreadsheet',
      ctaBuy: 'cómpralo ahora',
      ctaGuide: 'Leer la guía completa',
      trust: 'Recurso independiente • Guías actualizadas • Multilingüe • Enfocado en la seguridad',
    },
    what: {
      title: '¿Qué es el USFans Spreadsheet?',
      p1: 'El USFans Spreadsheet es un directorio seleccionado y basado en categorías de mercancía con temática estadounidense. Organiza los tipos de productos más populares — desde calzado y sombreros hasta accesorios y fragancias — en una estructura sencilla y navegable para que siempre sepas dónde buscar.',
      p2: 'En lugar de abrir docenas de pestañas o adivinar dónde está un producto, puedes ir directamente a la colección correspondiente con un solo enlace claro. Está diseñado para reducir la fricción y ayudar a fanáticos y compradores a encontrar lo que quieren más rápido.',
    },
    categories: {
      title: 'Explora categorías populares',
      subtitle: 'Elige una categoría a continuación para ir directamente a la colección correspondiente en nuestro sitio principal.',
      dropdownLabel: 'Selecciona una categoría',
      dropdownPlaceholder: 'Elige una categoría...',
      gridCta: 'Explorar',
    },
    why: {
      title: '¿Por qué usar el USFans Spreadsheet?',
      f1title: 'Organización clara',
      f1text: 'Cada tipo de producto se agrupa en una categoría sencilla y predecible, sin desorden ni adivinanzas.',
      f2title: 'Acceso rápido',
      f2text: 'Los enlaces directos te llevan a la colección exacta en un clic, sin búsquedas ni filtros interminables.',
      f3title: 'Siempre actualizado',
      f3text: 'El recurso se mantiene y actualiza para que las categorías y guías sigan siendo útiles con el tiempo.',
      f4title: 'Hecho para fanáticos',
      f4text: 'Desde camisetas deportivas hasta accesorios, la estructura refleja lo que los fanáticos y compradores realmente buscan.',
    },
    guide: {
      title: 'Guía destacada',
      cardTitle: 'USFans Spreadsheet: La guía completa',
      cardDesc: 'Descubre qué es el spreadsheet, qué encontrarás dentro, cómo usarlo y obtén consejos prácticos, además de una útil tabla comparativa y preguntas frecuentes.',
      cardCta: 'Leer la guía',
      cardDate: 'Actualizado con regularidad',
    },
    articles: {
      title: 'Guías y artículos',
      subtitle: 'Guías detalladas sobre el USFans spreadsheet, reseñas, envíos, cupones, seguridad y más.',
      readMore: 'Leer artículo',
    },
    faq: {
      title: 'Preguntas frecuentes',
      q1: '¿Qué es el USFans Spreadsheet?',
      a1: 'Es un directorio basado en categorías que organiza la mercancía y ropa de fanáticos estadounidenses en una estructura sencilla y navegable con enlaces directos a cada colección.',
      q2: '¿Cómo uso los enlaces de categoría?',
      a2: 'Elige una categoría del menú desplegable o toca cualquier tarjeta de categoría. Serás llevado directamente a la colección correspondiente en el sitio principal.',
      q3: '¿Es este el sitio oficial de USFans?',
      a3: 'No. Este es un recurso informativo independiente que enlaza al sitio principal, donde realmente se venden los productos.',
      q4: '¿Necesito crear una cuenta para explorar?',
      a4: 'No se requiere cuenta. Puedes explorar todas las categorías y leer todas las guías de forma totalmente gratuita.',
      q5: '¿Cómo llego al sitio principal?',
      a5: 'Usa los botones "usfans spreadsheet" o "cómpralo ahora", o cualquier enlace de categoría: todos llevan al sitio principal.',
    },
    cta: {
      title: '¿Listo para explorar?',
      text: 'Explora todas las categorías o ve directamente al sitio principal para ver la colección completa.',
      button: 'Visitar el sitio principal',
      button2: 'usfans spreadsheet',
    },
  },
};